import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SearchProducts.css';

const SearchProducts = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({
    name: '',
    polos: '',
    tensao: '',
    precoMin: '',
    precoMax: '',
    marca: '',
  });
  const [marcas, setMarcas] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Busca todos os produtos ao carregar a página
    fetch('https://crmesquita.com.br/api/produtos/')
      .then((response) => response.json())
      .then((data) => {
        setProducts(data);
        setFilteredProducts(data);
      })
      .catch((error) => console.error('Erro ao buscar produtos:', error));

    // Busca todas as marcas cadastradas
    fetch('https://crmesquita.com.br/api/marcas/')
      .then((response) => response.json())
      .then((data) => setMarcas(data))
      .catch((error) => console.error('Erro ao buscar marcas:', error));
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const applyFilters = () => {
    let filtered = products;

    // Filtra por nome
    if (filters.name) {
      filtered = filtered.filter((product) =>
        product.nome.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    // Filtra por polos
    if (filters.polos) {
      filtered = filtered.filter((product) =>
        product.polos.toLowerCase().includes(filters.polos.toLowerCase())
      );
    }

    // Filtra por tensão
    if (filters.tensao) {
      filtered = filtered.filter((product) =>
        product.tensao.toLowerCase().includes(filters.tensao.toLowerCase())
      );
    }

    // Filtra por preço mínimo
    if (filters.precoMin) {
      filtered = filtered.filter(
        (product) => parseFloat(product.preco) >= parseFloat(filters.precoMin)
      );
    }

    // Filtra por preço máximo
    if (filters.precoMax) {
      filtered = filtered.filter(
        (product) => parseFloat(product.preco) <= parseFloat(filters.precoMax)
      );
    }

    // Filtra por marca
    if (filters.marca) {
      filtered = filtered.filter(
        (product) => product.marca?.nome === filters.marca
      );
    }

    setFilteredProducts(filtered);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyFilters();
    }
  };

  const handleCardClick = (productId) => {
    navigate(`/produto/${productId}`);
  };

  return (
    <div className="search-products-container">
      {/* Filtros na Esquerda */}
      <aside className="filters-container">
        <h3>Filtros</h3>
        <div className="filter-group">
          <label htmlFor="name">Nome</label>
          <input
            type="text"
            id="name"
            name="name"
            value={filters.name}
            onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
            placeholder="Buscar por nome"
          />
        </div>
        <div className="filter-group">
          <label htmlFor="polos">Polos</label>
          <input
            type="number"
            id="polos"
            name="polos"
            value={filters.polos}
            onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
            placeholder="Ex: 2, 4, 6"
          />
        </div>
        <div className="filter-group">
          <label htmlFor="tensao">Tensão</label>
          <input
            type="text"
            id="tensao"
            name="tensao"
            value={filters.tensao}
            onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
            placeholder="Ex: 220V, 380V"
          />
        </div>
        <div className="filter-group">
          <label htmlFor="precoMin">Preço Mínimo</label>
          <input
            type="number"
            id="precoMin"
            name="precoMin"
            value={filters.precoMin}
            onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
            placeholder="Ex: 100"
          />
        </div>
        <div className="filter-group">
          <label htmlFor="precoMax">Preço Máximo</label>
          <input
            type="number"
            id="precoMax"
            name="precoMax"
            value={filters.precoMax}
            onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
            placeholder="Ex: 1000"
          />
        </div>
        <div className="filter-group">
          <label htmlFor="marca">Marca</label>
          <select
            id="marca"
            name="marca"
            value={filters.marca}
            onChange={handleFilterChange}
            onKeyPress={handleKeyPress}
          >
            <option value="">Todas as Marcas</option>
            {marcas.map((marca) => (
              <option key={marca.id} value={marca.nome}>
                {marca.nome}
              </option>
            ))}
          </select>
        </div>
        <button className="apply-filters-button" onClick={applyFilters}>
          Aplicar Filtros
        </button>
      </aside>

      {/* Lista de Produtos na Direita */}
      <main className="products-list-container">
        <h2 className="products-list-header">Produtos</h2>
        <div className="products-grid">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="product-card"
              onClick={() => handleCardClick(product.id)} // Torna o card clicável
            >
              <img
                src={product.marca?.imagem || 'https://via.placeholder.com/150'}
                alt={product.nome}
                className="product-image"
              />
              <h3 className="product-name">{product.nome}</h3>
              <p className="product-price">
                {parseFloat(product.preco).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default SearchProducts;